<template>
    <div class="emjouter">

        <div class="emojholder">
            <img class="emojcoalpic" src="/Coal_JE4_BE32_NBG.png" />
            <div class="emoj emojplace emojback strokeme">{{ nft.calc_emoj("BACK") }}</div>
            <div class="emoj emojplace emojhat strokeme">{{ nft.calc_emoj("HAT") }}</div>
            <div class="emoj emojplace emojhand strokeme">{{ nft.calc_emoj("HAND") }}</div>
            <div class="emoj emojplace emojsky strokeme">{{ nft.calc_emoj("SKY") }}</div>
            <span class="emoj emojplace emojpet strokeme">{{ nft.calc_emoj("PET") }}</span>

        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';

export default {
    name: 'CoalRend'
    , data() {
        return {
            ENUMS: ENUMS
        }
    }
    , props: ["nft"]
    , mounted() {
    }
    , computed: {

    }, components: {}
    , methods: {
    }
}

</script>

<style scoped>
.strokeme {
    color: white;
    text-shadow:
    -1px -1px 0 black,
        1px -1px 0 black,
        -1px 1px 0 black,
        1px 1px 0 black,
        -2px -2px 0 black,
        2px -2px 0 black,
        -2px 2px 0 black,
        2px 2px 0 black;
        
}
.strokemew {
    color: white;
    text-shadow:
        -1px -1px 0 white,
        1px -1px 0 white,
        -1px 1px 0 white,
        1px 1px 0 white;
}


.emoj {
    font-size: 10pt;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.emojcoalpic {
    width: 100px;
}

.emjouter {
    display: flex;
    max-width: 100px;
    pointer-events:none;
    margin: auto;
    margin-top: 2%;
    /* margin: 0; */
}

.emojholder {
    display: flex;
    pointer-events:none;
}

.emojplace {
    position: relative;
}

.emojhat {
    left: -40%;
    top: 0%;
    font-size: 25pt;
}

.emojhand {
    left: -35%;
    top: 35%;
    font-size: 20pt;
    max-height: 50px;
}

.emojback {
    left: -8%;
    top: 10%;
    font-size: 13pt;
}

.emojsky {
    left: -85%;
    top: -10%;
    font-size: 15pt;
}

.emojpet {
    left: -95%;
    top: 70%;
    font-size: 15pt;
}
</style>